// extracted by mini-css-extract-plugin
export default {"appAlertDev":"styles_appAlertDev__iT0bW","cancelBtnStyle":"styles_cancelBtnStyle__oaAoW","yesBtnStyle":"styles_yesBtnStyle__zmOml"};